const SITES_WITH_STRATEGIES = (state, sitesWithStrategies) => {
  state.sitesWithStrategies = sitesWithStrategies;
};

const SELECTED_SITE_STRATEGIES = (state, selectedSiteStrategies) => {
  state.selectedSiteStrategies = selectedSiteStrategies;
};

const STRATEGY_CURRENT_ROUTE = (state, strategyCurrentRoute) => {
  state.strategyCurrentRoute = strategyCurrentRoute;
};

const SELECTED_SITE_STRATEGIES_IS_LOADING = (
  state,
  selectedSiteStrategiesIsLoading
) => {
  state.selectedSiteStrategiesIsLoading = selectedSiteStrategiesIsLoading;
};

const STRATEGY_SEARCH_TERM = (state, strategySearchTerm) => {
  state.strategySearchTerm = strategySearchTerm;
};

const STRATEGY_TODAYS_HISTORY = (state, strategyTodaysHistory) => {
  state.strategyTodaysHistory = strategyTodaysHistory;
};

const IS_HISTORY_LOADING = (state, isHistoryLoading) => {
  state.isHistoryLoading = isHistoryLoading;
};

const STRATEGY_INFO = (state, strategyInfo) => {
  state.strategyInfo = { ...state.strategyInfo, ...strategyInfo };
};

export default {
  SITES_WITH_STRATEGIES,
  SELECTED_SITE_STRATEGIES,
  STRATEGY_CURRENT_ROUTE,
  SELECTED_SITE_STRATEGIES_IS_LOADING,
  STRATEGY_SEARCH_TERM,
  STRATEGY_TODAYS_HISTORY,
  IS_HISTORY_LOADING,
  STRATEGY_INFO,
};
